import React, { useEffect } from "react";
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";
import { ThemeProvider } from "styled-components";
import { Helmet } from "react-helmet";
import Favicon from "../assets/images/88i-favicon.jpeg";
import { TGlobalState } from "../@types/State/TGlobalState";
import { TDispatch } from "../@types/TDispatch";
import { TRoute } from "../@types/TRoute";
import ProductsPage from "../pages/Products";
import { getWhiteLabelGroupsIfNeeded } from "../store/actions/whiteLabelGroup/getWhiteLabelGroup";
import {
  getWhiteLabelGroupsSelector,
  templateWhiteLabelGroupSelector,
} from "../store/selectors";
import { getGroupIdHashByUrlLocation } from "../utils/url";
import Template from "../template";
import { Loading } from "./styles";

const Routes: React.FC<TRoute> = ({
  getWhiteLabelGroup,
  getWhiteLabelGroupState,
  templateWhiteLabelGroupState,
}) => {
  useEffect(() => {
    const groupId = getGroupIdHashByUrlLocation(window.location);
    if (groupId) {
      getWhiteLabelGroup({ groupId });
    } else {
      window.location.replace(
        `${process.env.REACT_APP_BASE_URL}/products/group/${process.env.REACT_APP_DEFAULT_GROUP}`
      );
    }
  }, []);

  const initializeGA = () => {
    if (process.env.REACT_APP_GLOBAL_GA) {
      ReactGA.initialize([
        {
          trackingId: process.env.REACT_APP_GLOBAL_GA,
          gaOptions: { allowLinker: true },
        },
      ]);
      ReactGA.ga("require", "linker");
      ReactGA.ga("linker:autoLink", [
        process.env.REACT_APP_88I_SALES_ENDPOINT,
        process.env.REACT_APP_88I_SEGUROS_ENDPOINT,
        process.env.REACT_APP_88I_SEGURADORA_ENDPOINT,
        process.env.REACT_APP_88I_LPS_ENDPOINT,
      ]);
    }
  };

  const initializeFBPixel = () => {
    if (
      process.env.REACT_APP_FACEBOOK_PIXEL_ID_GLOBAL &&
      process.env.REACT_APP_ENV === "prod"
    ) {
      ReactPixel.init(process.env.REACT_APP_FACEBOOK_PIXEL_ID_GLOBAL);
    }
  };

  const setFavIcon = () => {
    if (templateWhiteLabelGroupState.favicon) {
      return (
        <Helmet>
          <link rel="icon" href={templateWhiteLabelGroupState.favicon} />
          <link
            rel="apple-touch-icon"
            href={templateWhiteLabelGroupState.favicon}
          />
        </Helmet>
      );
    }
    return (
      <Helmet>
        <link rel="icon" href={Favicon} />
        <link rel="apple-touch-icon" href={Favicon} />
      </Helmet>
    );
  };

  return (
    <BrowserRouter>
      {getWhiteLabelGroupState.loading || !getWhiteLabelGroupState.data ? (
        <Loading />
      ) : (
        <ThemeProvider theme={getWhiteLabelGroupState.data.theme}>
          {initializeGA()}
          {initializeFBPixel()}
          {setFavIcon()}
          <Template>
            <Switch>
              <Route
                key="products"
                exact
                path="/products/group/:groupId"
                component={ProductsPage}
              />
            </Switch>
          </Template>
        </ThemeProvider>
      )}
    </BrowserRouter>
  );
};

const mapStateToProps = (state: TGlobalState) => {
  return {
    getWhiteLabelGroupState: getWhiteLabelGroupsSelector(state),
    templateWhiteLabelGroupState: templateWhiteLabelGroupSelector(state),
  };
};

const mapDispatchtoProps = (dispatch: TDispatch) =>
  bindActionCreators(
    {
      getWhiteLabelGroup: getWhiteLabelGroupsIfNeeded,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchtoProps)(Routes);
